//
// Module for the Withholdings Edit view
//
rs.module("participant/benefit/withholdings/edit",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility",
        "pg/numerical-input"
    ],

    function (selectHelper, eventBanner, visibility, numericalInput) {

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls, codeValues, isCreate, originalState) {
            var withholdingForm = $.js(jsSelectors.withholdingForm);

            var w4PChangeEffectiveDate = withholdingForm.js(jsSelectors.w4PChangeEffectiveDate);
            var benefitClaimPaymentKey = withholdingForm.js(jsSelectors.benefitClaimPaymentKey);

            var withholdingTypeSelect = withholdingForm.js(jsSelectors.withholdingTypeSelect);
            var effectiveDateInput = withholdingForm.js(jsSelectors.effectiveDateInput);
            var stateSelect = withholdingForm.js(jsSelectors.stateSelect);
            var stateSelectHelper = selectHelper.getHelper(stateSelect);
            var withholdingElectionSelect = withholdingForm.js(jsSelectors.withholdingElectionSelect);
            var withholdingElectionSelectHelper = selectHelper.getHelper(withholdingElectionSelect);
            var originalFederalElection = withholdingForm.js(jsSelectors.originalFederalElection);

            var flatAmountInput = withholdingForm.js(jsSelectors.flatAmountInput);
            var percentInput = withholdingForm.js(jsSelectors.percentInput);
            var filingStatusSelect = withholdingForm.js(jsSelectors.filingStatusSelect);
            var filingStatusSelectHelper = selectHelper.getHelper(filingStatusSelect);
            var allowancesField = withholdingForm.js(jsSelectors.allowancesField);
            var allowancesInput = allowancesField.js(jsSelectors.allowancesInput);
            var extraWithholdingField = withholdingForm.js(jsSelectors.extraWithholdingField);
            var extraWithholdingInput = extraWithholdingField.js(jsSelectors.extraWithholdingInput);

            var newFederalW4PFields = withholdingForm.js(jsSelectors.newFederalW4PFields);

            var annualJobPayInput = newFederalW4PFields.js(jsSelectors.annualJobPayInput);
            var otherAnnualPensionInput = newFederalW4PFields.js(jsSelectors.otherAnnualPensionInput);
            var totalJobPensionIncomeInput = newFederalW4PFields.js(jsSelectors.totalJobPensionIncomeInput);

            var childDependentCreditInput = newFederalW4PFields.js(jsSelectors.childDependentCreditInput);
            var otherDependentCreditInput = newFederalW4PFields.js(jsSelectors.otherDependentCreditInput);
            var otherTaxCreditInput = newFederalW4PFields.js(jsSelectors.otherTaxCreditInput);
            var totalTaxCreditInput = newFederalW4PFields.js(jsSelectors.totalTaxCreditInput);

            var extraAmountPerPaymentInput = newFederalW4PFields.js(jsSelectors.extraAmountPerPaymentInput);

            numericalInput.registerSumInputs(totalJobPensionIncomeInput, 2, annualJobPayInput, otherAnnualPensionInput);

            numericalInput.registerSumInputs(totalTaxCreditInput, 2, childDependentCreditInput, otherDependentCreditInput, otherTaxCreditInput);

            // Maintain state drop down options, switch withholding elections
            withholdingTypeSelect.change(function () {
                ManageStateSelect();

                // if withholding elections are disabled, it is a Correction record and should not be able to be changed from Flat Amount
                if (!withholdingElectionSelect.prop('disabled')) {
                    withholdingElectionSelect.clearErrors();

                    withholdingElectionSelectHelper.loadOptionsFrom(
                        ajaxUrls.populateElectionsUrl,
                        {
                            isWithholdingTypeState: this.value == codeValues.state,
                            benefitClaimPaymentKey: benefitClaimPaymentKey.val(),
                            originalFederalElection: originalFederalElection.val()
                        },
                        { withBlank: true });
                }

                ToggleFederalW4PDisplay();
            });

            // Re-populate state drop down options
            effectiveDateInput.change(_.debounce(function () {
                ManageStateSelect();
                ToggleFederalW4PDisplay();
            }, 500));

            // Clear and disable the amount fields and re-enable appropriate fields based on selection
            withholdingElectionSelect.change(function () {
                withholdingElectionSelect.clearErrors();
                ToggleAmountFields(withholdingElectionSelect.val());
                ToggleFederalW4PDisplay();
            });

            // Toggle and populate the state drop down based on type selection and effective date
            function ManageStateSelect() {
                var stateSelected = withholdingTypeSelect.val() == codeValues.state;
                if (!stateSelected) {
                    stateSelectHelper.setValue('');
                }
                stateSelectHelper.setDisabled(!stateSelected);
                stateSelect.clearErrors();

                eventBanner.removeAllMessages();

                if (stateSelected && effectiveDateInput.val() && effectiveDateInput.valid()) {
                    stateSelectHelper.loadOptionsFrom(
                        ajaxUrls.populateStatesUrl,
                        { effectiveDate: effectiveDateInput.val(), isCreate: isCreate, originalState: originalState, defaultState: stateSelect.val() },
                        { withBlank: true });
                }
            }

            // Enable the appropriate fields based on the given election
            function ToggleAmountFields(electionCodeKey) {
                if (electionCodeKey == codeValues.flatAmount ||
                    electionCodeKey == codeValues.percent) {

                    filingStatusSelectHelper.setValue('');
                    filingStatusSelect.clearErrors();
                    filingStatusSelectHelper.setDisabled(true);

                    allowancesInput.val('').clearErrors();
                    allowancesInput.prop('disabled', true);

                    extraWithholdingInput.val('').clearErrors();
                    extraWithholdingInput.prop('disabled', true);
                    extraAmountPerPaymentInput.val('').clearErrors();
                    extraAmountPerPaymentInput.prop('disabled', true);

                    if (electionCodeKey == codeValues.flatAmount) {
                        flatAmountInput.prop('disabled', false);

                        percentInput.val('').clearErrors();
                        percentInput.prop('disabled', true);
                    } else {
                        flatAmountInput.val('').clearErrors();
                        flatAmountInput.prop('disabled', true);

                        percentInput.prop('disabled', false);
                    }
                } else if (
                    electionCodeKey == codeValues.taxTable ||
                    electionCodeKey == codeValues.taxTablePlusExtra) {

                    flatAmountInput.val('').clearErrors();
                    flatAmountInput.prop('disabled', true);

                    percentInput.val('').clearErrors();
                    percentInput.prop('disabled', true);

                    // enable applicable fields
                    filingStatusSelectHelper.setDisabled(false);
                    allowancesInput.prop('disabled', false);

                    if (electionCodeKey == codeValues.taxTable) {
                        extraWithholdingInput.val('').clearErrors();
                        extraWithholdingInput.prop('disabled', true);
                        extraAmountPerPaymentInput.val('').clearErrors();
                        extraAmountPerPaymentInput.prop('disabled', true);
                    } else {
                        extraWithholdingInput.prop('disabled', false);
                        extraAmountPerPaymentInput.prop('disabled', false);
                    }
                } else {
                    flatAmountInput.val('').clearErrors();
                    flatAmountInput.prop('disabled', true);

                    percentInput.val('').clearErrors();
                    percentInput.prop('disabled', true);

                    filingStatusSelectHelper.setValue('');
                    filingStatusSelect.clearErrors();
                    filingStatusSelectHelper.setDisabled(true);

                    allowancesInput.val('').clearErrors();
                    allowancesInput.prop('disabled', true);

                    extraWithholdingInput.val('').clearErrors();
                    extraWithholdingInput.prop('disabled', true);
                    extraAmountPerPaymentInput.val('').clearErrors();
                    extraAmountPerPaymentInput.prop('disabled', true);
                }
            }

            // Display the new or old W4P fields fields based on the withholding type and effective date selections
            function ToggleFederalW4PDisplay() {

                let federalSelected = withholdingTypeSelect.val() == codeValues.federal;

                if (!federalSelected || (effectiveDateInput.val() && effectiveDateInput.valid())) {

                    // show the new fields if federal and the entered effective date is >= than the w4PChangeEffectiveDate
                    let showNewW4PFields = federalSelected && new Date(effectiveDateInput.val() + 'T00:00:00') >= new Date(w4PChangeEffectiveDate.val());

                    let taxTablePlusExtraSelected = withholdingElectionSelect.val() == codeValues.taxTablePlusExtra;
                    let taxTableOptionSelected = taxTablePlusExtraSelected || withholdingElectionSelect.val() == codeValues.taxTable;
                    let enableNewW4PFields = showNewW4PFields && taxTableOptionSelected;

                    extraWithholdingInput.prop('disabled', !taxTablePlusExtraSelected || showNewW4PFields);
                    extraAmountPerPaymentInput.prop('disabled', !taxTablePlusExtraSelected || !showNewW4PFields);

                    visibility.setVisible(extraWithholdingField, !showNewW4PFields);

                    visibility.setVisible(allowancesField, !showNewW4PFields);

                    newFederalW4PFields.find('input').not(extraAmountPerPaymentInput).each(function () {
                        $(this).prop('disabled', !enableNewW4PFields);

                        if (!enableNewW4PFields) {
                            $(this).val('$0.00');
                        }
                    });

                    visibility.setVisible(newFederalW4PFields, showNewW4PFields);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);